import { BaseConstants } from './baseConstants';

export class OhatStatus extends BaseConstants {
  static readonly fine = new OhatStatus('fine', '健康的', 'Healthy', 0);
  static readonly bad = new OhatStatus('bad', 'やや病的', 'Changes', 1);
  static readonly diseased = new OhatStatus('diseased', '病的', 'Unhealthy', 2);

  private constructor(
    public readonly key: string,
    public readonly label: string,
    public readonly labelEn: string,
    public readonly score: number,
  ) {
    super();
  }

  /** 表示言語に応じたラベルを返す。 */
  getLabel(lang?: string): string {
    return lang?.startsWith('en') ? this.labelEn : this.label;
  }

  static getByScore(score: number) {
    return this.getAll().find((v) => v.score === score);
  }
}
